import React from 'react';
import { Field } from 'redux-form';
import { minLength, required, validateAddress, validateCity, notEmpty, maxLength } from '../../../utils/validate';
import { toNumber } from '../../../utils/formatters';
import OptionList from "../../Forms/OptionList/optionList";
import Input from '../../Forms/Input/input';
import Select from '../../Forms/Select/select';
import { memoize } from 'ramda';

const validateZip = minLength.bind(null, 5);

const memoizeMaxLength = memoize((max) => maxLength.bind(null, Number(max)));

const usStatesWithMilitary = [
  {
    "value": "AL",
    "text": "AL"
  },
  {
    "value": "AK",
    "text": "AK"
  },
  {
    "value": "AA",
    "text": "AA"
  },
  {
    "value": "AE",
    "text": "AE"
  },
  {
    "value": "AP",
    "text": "AP"
  },
  {
    "value": "AZ",
    "text": "AZ"
  },
  {
    "value": "AR",
    "text": "AR"
  },
  {
    "value": "CA",
    "text": "CA"
  },
  {
    "value": "CO",
    "text": "CO"
  },
  {
    "value": "CT",
    "text": "CT"
  },
  {
    "value": "DE",
    "text": "DE"
  },
  {
    "value": "DC",
    "text": "DC"
  },
  {
    "value": "FL",
    "text": "FL"
  },
  {
    "value": "GA",
    "text": "GA"
  },
  {
    "value": "HI",
    "text": "HI"
  },
  {
    "value": "ID",
    "text": "ID"
  },
  {
    "value": "IL",
    "text": "IL"
  },
  {
    "value": "IN",
    "text": "IN"
  },
  {
    "value": "IA",
    "text": "IA"
  },
  {
    "value": "KS",
    "text": "KS"
  },
  {
    "value": "KY",
    "text": "KY"
  },
  {
    "value": "LA",
    "text": "LA"
  },
  {
    "value": "ME",
    "text": "ME"
  },
  {
    "value": "MD",
    "text": "MD"
  },
  {
    "value": "MA",
    "text": "MA"
  },
  {
    "value": "MI",
    "text": "MI"
  },
  {
    "value": "MN",
    "text": "MN"
  },
  {
    "value": "MS",
    "text": "MS"
  },
  {
    "value": "MO",
    "text": "MO"
  },
  {
    "value": "MT",
    "text": "MT"
  },
  {
    "value": "NE",
    "text": "NE"
  },
  {
    "value": "NV",
    "text": "NV"
  },
  {
    "value": "NH",
    "text": "NH"
  },
  {
    "value": "NJ",
    "text": "NJ"
  },
  {
    "value": "NM",
    "text": "NM"
  },
  {
    "value": "NY",
    "text": "NY"
  },
  {
    "value": "NC",
    "text": "NC"
  },
  {
    "value": "ND",
    "text": "ND"
  },
  {
    "value": "OH",
    "text": "OH"
  },
  {
    "value": "OK",
    "text": "OK"
  },
  {
    "value": "OR",
    "text": "OR"
  },
  {
    "value": "PA",
    "text": "PA"
  },
  {
    "value": "RI",
    "text": "RI"
  },
  {
    "value": "SC",
    "text": "SC"
  },
  {
    "value": "SD",
    "text": "SD"
  },
  {
    "value": "TN",
    "text": "TN"
  },
  {
    "value": "TX",
    "text": "TX"
  },
  {
    "value": "UT",
    "text": "UT"
  },
  {
    "value": "VT",
    "text": "VT"
  },
  {
    "value": "VA",
    "text": "VA"
  },
  {
    "value": "WA",
    "text": "WA"
  },
  {
    "value": "WV",
    "text": "WV"
  },
  {
    "value": "WI",
    "text": "WI"
  },
  {
    "value": "WY",
    "text": "WY"
  }
];

const MailingAddressFieldSet = () => {

  return (
    <fieldset className="container">
      <legend className="row">Mailing Address</legend>
      <div className="row">
        <div className="col-12 col-lg-6">
          <Field
            name="homeAddress"
            label="Home address"
            component={Input}
            type="text"
            validate={[required, validateAddress, notEmpty, memoizeMaxLength("32")]}
            required={true}
            htmlAttributes={{
              maxLength: "32"
            }}
          />
        </div>
        <div className="col-12 col-lg-6">
          <Field
            name="aptSuiteBldg"
            label="Apt,suite,bldg (opt)"
            component={Input}
            type="text"
            validate={[validateAddress, memoizeMaxLength("32")]}
            htmlAttributes={{
              maxLength: "32"
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-6">
          <Field
            name="cityTown"
            label="City / town"
            component={Input}
            type="text"
            validate={[required, validateCity, notEmpty, memoizeMaxLength("19")]}
            required={true}
            htmlAttributes={{
              maxLength: "19"
            }}
          />
        </div>
        <div className="col-12 col-lg-3">
          <Field
            name="state"
            label="State"
            component={Select}
            type="select"
            defaultValue=""
            validate={[required]}
            required={true}
          >
            <OptionList options={usStatesWithMilitary} />
          </Field>
        </div>
        <div className="col-12 col-lg-3">
          <Field
            name="zip"
            label="Zip code"
            component={Input}
            type="text"
            normalize={toNumber}
            validate={[required, validateZip]}
            required={true}
            htmlAttributes={{
              minLength: "5",
              maxLength: "5"
            }}
          />
        </div>
      </div>
    </fieldset>);
};

export default MailingAddressFieldSet;

